<div class="flex flex-row max-sm:flex-col h-full">
  <app-links></app-links>
  <div class="flex flex-col w-full">
    <div class="relative">
      <div
        class="absolute z-10 inset-0 flex flex-row justify-between items-center text-4xl font-bold text-white ml-16 mr-24"
      >
        <div>
          {{ userStore.contract().name }}
          <hr class="border-2 border-tertiary" />
        </div>
        <img
          class="h-40 w-auto rounded-md"
          [src]="'/api/image/' + userStore.contract().logo"
        />
      </div>
      <img
        [src]="'/api/image/' + userStore.contract().wallpaper"
        class="filter grayscale blur-xs md:w-full max-h-52 w-auto object-cover"
      />
      <!--<div class="md:w-full h-52 w-auto object-cover bg-gray-200"></div>-->
    </div>
    <app-folders class="m-5"></app-folders>
    <hr class="border-0.5 border-primary/25 mx-20" />
    <app-news class="m-5"></app-news>
    <hr class="border-0.5 border-primary/25 mx-20" />
  </div>
</div>
